var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMValesSodexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{fill:#2eccb6;}.cls-4{fill:#329be6;}.cls-5{fill:#0b5c96;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_vales_sodexo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sodexo"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11 21.52 41.5 21.52 41.5 25.48 13 25.48 11 25.48 11 21.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13 27.99 41.5 27.99 41.5 31.95 15 31.95 13 31.95 13 27.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15,
    y: 34.46,
    width: 26.5,
    height: 3.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9,
    y: 14.99,
    width: 32.5,
    height: 3.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.78,51.24A3.78,3.78,0,1,1,22,47.46,3.78,3.78,0,0,1,25.78,51.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,55a3.78,3.78,0,1,1,3.78-3.78A3.78,3.78,0,0,1,44,55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57 14.98 48 14.98 48 40.98 48 40.98 48 44.96 48 44.96 44 44.96 17 44.96 17 40.98 40.49 40.98 44 40.98 44 40.93 44.01 40.93 44.01 38.43 44.01 34.46 44.01 34.45 44.01 31.96 44.01 31.95 44.01 27.99 44.01 27.98 44.01 25.49 44.01 25.48 44.01 21.52 44.01 21.47 44.01 19.02 44.01 18.97 44.01 14.99 44.01 12.49 44 12.49 44 10.98 45 10.98 48 10.98 57 10.98 57 14.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11 22 11.48 21.52 11 21.52 11 22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.5,11V8.88a.39.39,0,0,1,.11-.27L33.28.28a.4.4,0,0,0-.56,0L20.51,12.49h21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.9,47.46a.4.4,0,0,1-.4-.4V40.93H12.9a.4.4,0,0,1-.4-.4V34.46H10.9a.4.4,0,0,1-.4-.4V28H8.9a.4.4,0,0,1-.4-.4V24.5L.28,32.72a.4.4,0,0,0,0,.56L16.1,49.1a6.39,6.39,0,0,1,.9-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.72,32.72,50.5,17.5v21h0v8.58a.4.4,0,0,1-.4.4H49a6,6,0,0,1,.89,1.65L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.83,52.42a6.22,6.22,0,0,1,1.17-5H27a6.22,6.22,0,0,1,1.28,3.78,6.29,6.29,0,0,1-4.14,5.9l8.58,8.58a.4.4,0,0,0,.56,0l8.59-8.59A6.31,6.31,0,0,1,37.83,52.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44,11H57v4H48v0l2.5,2.5v0h8.6a.4.4,0,0,0,.4-.4V8.88a.4.4,0,0,0-.4-.4H41.9a.39.39,0,0,0-.29.13L44,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11,21.52h.48L14,19H9V15h9l2.5-2.5H6.9a.4.4,0,0,0-.4.4v8.18a.4.4,0,0,0,.4.4H8.5v3L11,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22,55a3.78,3.78,0,0,1-3.78-3.78v0L16.1,49.1a6.26,6.26,0,0,0,5.15,8.37,6.32,6.32,0,0,0,2.89-.33L22,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.78,51.24A3.78,3.78,0,0,1,44,55h0l-2.11,2.11a5.93,5.93,0,0,0,1.38.34,6.28,6.28,0,0,0,7-6.23,6,6,0,0,0-.39-2.13l-2.11,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.1,47.46a.4.4,0,0,0,.4-.4V38.48h0v-21L48,15V41h0v4H17V41H44v0h0V34.46h0V32h0V28h0V25.49h0v-13h0V11L41.61,8.61a.39.39,0,0,0-.11.27v3.61h-21L18,15H41.5v4H14l-2.55,2.55h30v4H11V22L8.5,24.5v3.09a.4.4,0,0,0,.4.4h1.6v6.07a.4.4,0,0,0,.4.4h1.6v6.07a.4.4,0,0,0,.4.4h1.6v6.13a.4.4,0,0,0,.4.4H17a6.39,6.39,0,0,0-.9,1.64l2.12,2.12A3.78,3.78,0,1,1,22,55l2.12,2.12a6.29,6.29,0,0,0,4.14-5.9A6.22,6.22,0,0,0,27,47.46H39a6.22,6.22,0,0,0-1.17,5,6.31,6.31,0,0,0,4,4.71L44,55a3.78,3.78,0,1,1,3.8-3.8l2.11-2.11A6,6,0,0,0,49,47.46ZM13,32V28H41.5v4H13Zm2,6.48v-4H41.5v4Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMValesSodexo);
export default __webpack_public_path__ + "static/media/m_vales_sodexo.1531e432135955ad137d004687f3ba77.svg";
export { ForwardRef as ReactComponent };